import translation from 'translation';
const { t } = translation;

export const twitterDefaultData = () => {
  return [
    {
      username: '@sausagangelo',
      time: '2021-11-20 14:50:36',
      description: t('onboarding:sampleTweetForSetupStep1'),
      like_count: '3156',
      copy_count: '295',
      avatar:
        'files/twitter/2022_7_2/qhLUGSxykOUUtJb73BjW7HhpObBo8ZjrHXvuIysDKCdSqI8pHIxcPIicxFkwusJb.jpg',
    },
    {
      username: '@blackmigraine',
      time: '2022-06-13 13:27:10',
      description: t('onboarding:sampleTweetForSetupStep2'),
      like: '13889',
      comment: '285',
      avatar:
        'files/twitter/2022_6_23/fg4xfxzxoMcxIrClZHkPzgVdm8zFrdcJnmn7mpat4p4nYsJ3Zyte9rVkAuPU4G9Z.jpg',
    },
    {
      username: '@virotechnician',
      time: '2022-08-13 07:36:31',
      description: t('onboarding:sampleTweetForSetupStep3'),
      like: '253',
      comment: '7',
      avatar:
        'files/twitter/2022_6_26/QQdshL0mEC15ZRxtWK5uADVnEAZgttCtSBTVn7u8U4qKj0g3JLRjISupbbrG2Lq0.jpg',
    },
    {
      username: '@mkamalr2',
      time: '2021-12-23 12:02:05',
      description: t('onboarding:sampleTweetForSetupStep4'),
      like: '482',
      comment: '5',
      avatar:
        'files/twitter/2022_7_9/AgBU6Pmjajry64tDfwT6P0DPTfqpsENsSFiNdM0feOBxXYnIULl0Dl3Jg4yBlgn4.jpg',
    },
    {
      username: '@peymanyazdani_',
      time: '2021-12-17 20:29:35',
      description: t('onboarding:sampleTweetForSetupStep5'),
      like: '956',
      comment: '2',
      avatar:
        'files/twitter/2022_6_12/9dk9HUyzGLVdiKxvclMABr9z3m4OKA24KfcXOvnH9mRPLHcNAwRdJnVnCkS1Rf9q.jpg',
    },
  ];
};

export const twitterDefaultWordCloudData = () => {
  return {
    total: [
      {
        word: t('onboarding:sampleWordForWordCloud1'),
        count: 23471,
      },
      {
        word: t('onboarding:sampleWordForWordCloud2'),
        count: 23287,
      },
      {
        word: t('onboarding:sampleWordForWordCloud3'),
        count: 22769,
      },
      {
        word: t('onboarding:sampleWordForWordCloud4'),
        count: 22688,
      },
      {
        word: t('onboarding:sampleWordForWordCloud5'),
        count: 22378,
      },
      {
        word: t('onboarding:sampleWordForWordCloud6'),
        count: 19609,
      },
      {
        word: t('onboarding:sampleWordForWordCloud7'),
        count: 17820,
      },
      {
        count: 17475,
        word: t('onboarding:sampleWordForWordCloud8'),
      },
      {
        word: t('onboarding:sampleWordForWordCloud9'),
        count: 16954,
      },
      {
        word: t('onboarding:sampleWordForWordCloud10'),
        count: 16558,
      },
      {
        count: 16522,
        word: t('onboarding:sampleWordForWordCloud11'),
      },
      {
        word: t('onboarding:sampleWordForWordCloud12'),
        count: 15644,
      },
      {
        word: t('onboarding:sampleWordForWordCloud13'),
        count: 14735,
      },
      {
        count: 14690,
        word: t('onboarding:sampleWordForWordCloud14'),
      },
      {
        word: t('onboarding:sampleWordForWordCloud15'),
        count: 14602,
      },
      {
        word: t('onboarding:sampleWordForWordCloud16'),
        count: 13508,
      },
      {
        count: 13383,
        word: t('onboarding:sampleWordForWordCloud17'),
      },
      {
        word: t('onboarding:sampleWordForWordCloud18'),
        count: 13263,
      },
      {
        word: t('onboarding:sampleWordForWordCloud19'),
        count: 13098,
      },
      {
        count: 13005,
        word: t('onboarding:sampleWordForWordCloud20'),
      },
      {
        word: t('onboarding:sampleWordForWordCloud21'),
        count: 12832,
      },
      {
        word: t('onboarding:sampleWordForWordCloud22'),
        count: 12724,
      },
      {
        word: t('onboarding:sampleWordForWordCloud23'),
        count: 12500,
      },
      {
        word: t('onboarding:sampleWordForWordCloud24'),
        count: 12223,
      },
      {
        count: 11574,
        word: t('onboarding:sampleWordForWordCloud25'),
      },
      {
        count: 11398,
        word: t('onboarding:sampleWordForWordCloud26'),
      },
      {
        count: 10578,
        word: t('onboarding:sampleWordForWordCloud27'),
      },
      {
        count: 10530,
        word: t('onboarding:sampleWordForWordCloud28'),
      },
      {
        count: 10315,
        word: t('onboarding:sampleWordForWordCloud29'),
      },
      {
        count: 10028,
        word: t('onboarding:sampleWordForWordCloud30'),
      },
      {
        count: 9850,
        word: t('onboarding:sampleWordForWordCloud31'),
      },
      {
        count: 9719,
        word: t('onboarding:sampleWordForWordCloud32'),
      },
      {
        count: 9549,
        word: t('onboarding:sampleWordForWordCloud33'),
      },
      {
        count: 8367,
        word: t('onboarding:sampleWordForWordCloud34'),
      },
      {
        count: 8026,
        word: t('onboarding:sampleWordForWordCloud35'),
      },
      {
        count: 7859,
        word: t('onboarding:sampleWordForWordCloud36'),
      },
      {
        count: 7696,
        word: t('onboarding:sampleWordForWordCloud37'),
      },
      {
        count: 7661,
        word: t('onboarding:sampleWordForWordCloud38'),
      },
      {
        count: 7576,
        word: t('onboarding:sampleWordForWordCloud39'),
      },
      {
        count: 7263,
        word: t('onboarding:sampleWordForWordCloud40'),
      },
      {
        count: 7221,
        word: t('onboarding:sampleWordForWordCloud41'),
      },
      {
        count: 7190,
        word: t('onboarding:sampleWordForWordCloud42'),
      },
      {
        count: 7127,
        word: t('onboarding:sampleWordForWordCloud43'),
      },
      {
        count: 7097,
        word: t('onboarding:sampleWordForWordCloud44'),
      },
      {
        count: 6879,
        word: t('onboarding:sampleWordForWordCloud45'),
      },
      {
        count: 6873,
        word: t('onboarding:sampleWordForWordCloud46'),
      },
      {
        count: 6596,
        word: t('onboarding:sampleWordForWordCloud47'),
      },
      {
        count: 6500,
        word: t('onboarding:sampleWordForWordCloud48'),
      },
      {
        count: 6411,
        word: t('onboarding:sampleWordForWordCloud49'),
      },
      {
        count: 6335,
        word: t('onboarding:sampleWordForWordCloud50'),
      },
      {
        count: 6168,
        word: t('onboarding:sampleWordForWordCloud51'),
      },
      {
        count: 6116,
        word: t('onboarding:sampleWordForWordCloud52'),
      },
      {
        count: 6105,
        word: t('onboarding:sampleWordForWordCloud53'),
      },
      {
        count: 6104,
        word: t('onboarding:sampleWordForWordCloud54'),
      },
      {
        count: 6084,
        word: t('onboarding:sampleWordForWordCloud55'),
      },
      {
        count: 6080,
        word: t('onboarding:sampleWordForWordCloud56'),
      },
      {
        count: 6051,
        word: t('onboarding:sampleWordForWordCloud57'),
      },
      {
        count: 6018,
        word: t('onboarding:sampleWordForWordCloud58'),
      },
      {
        count: 5989,
        word: t('onboarding:sampleWordForWordCloud59'),
      },
      {
        count: 5979,
        word: t('onboarding:sampleWordForWordCloud60'),
      },
      {
        count: 5960,
        word: t('onboarding:sampleWordForWordCloud61'),
      },
      {
        count: 5926,
        word: t('onboarding:sampleWordForWordCloud62'),
      },
      {
        count: 5773,
        word: t('onboarding:sampleWordForWordCloud63'),
      },
      {
        count: 5765,
        word: t('onboarding:sampleWordForWordCloud64'),
      },
      {
        count: 5522,
        word: t('onboarding:sampleWordForWordCloud65'),
      },
      {
        count: 5512,
        word: t('onboarding:sampleWordForWordCloud66'),
      },
      {
        count: 5485,
        word: t('onboarding:sampleWordForWordCloud67'),
      },
      {
        count: 5372,
        word: t('onboarding:sampleWordForWordCloud68'),
      },
      {
        count: 5251,
        word: t('onboarding:sampleWordForWordCloud69'),
      },
      {
        count: 5180,
        word: t('onboarding:sampleWordForWordCloud70'),
      },
      {
        count: 5134,
        word: t('onboarding:sampleWordForWordCloud71'),
      },
      {
        count: 5115,
        word: t('onboarding:sampleWordForWordCloud72'),
      },
      {
        count: 5107,
        word: t('onboarding:sampleWordForWordCloud73'),
      },
      {
        count: 5096,
        word: t('onboarding:sampleWordForWordCloud74'),
      },
      {
        count: 5062,
        word: t('onboarding:sampleWordForWordCloud75'),
      },
      {
        count: 5036,
        word: t('onboarding:sampleWordForWordCloud76'),
      },
      {
        count: 5007,
        word: t('onboarding:sampleWordForWordCloud77'),
      },
      {
        count: 4998,
        word: t('onboarding:sampleWordForWordCloud78'),
      },
      {
        count: 4925,
        word: t('onboarding:sampleWordForWordCloud79'),
      },
      {
        count: 4887,
        word: t('onboarding:sampleWordForWordCloud80'),
      },
      {
        count: 4874,
        word: t('onboarding:sampleWordForWordCloud81'),
      },
      {
        count: 4858,
        word: t('onboarding:sampleWordForWordCloud82'),
      },
      {
        count: 4798,
        word: t('onboarding:sampleWordForWordCloud83'),
      },
      {
        count: 4737,
        word: t('onboarding:sampleWordForWordCloud84'),
      },
      {
        count: 4733,
        word: t('onboarding:sampleWordForWordCloud85'),
      },
      {
        count: 4722,
        word: t('onboarding:sampleWordForWordCloud86'),
      },
      {
        count: 4715,
        word: t('onboarding:sampleWordForWordCloud87'),
      },
      {
        count: 4696,
        word: t('onboarding:sampleWordForWordCloud88'),
      },
      {
        count: 4597,
        word: t('onboarding:sampleWordForWordCloud89'),
      },
      {
        count: 4533,
        word: t('onboarding:sampleWordForWordCloud90'),
      },
      {
        count: 4532,
        word: t('onboarding:sampleWordForWordCloud91'),
      },
      {
        count: 4484,
        word: t('onboarding:sampleWordForWordCloud92'),
      },
      {
        count: 4477,
        word: t('onboarding:sampleWordForWordCloud93'),
      },
      {
        count: 4447,
        word: t('onboarding:sampleWordForWordCloud94'),
      },
      {
        count: 4433,
        word: t('onboarding:sampleWordForWordCloud95'),
      },
      {
        count: 4375,
        word: t('onboarding:sampleWordForWordCloud96'),
      },
      {
        count: 4368,
        word: t('onboarding:sampleWordForWordCloud97'),
      },
      {
        count: 4367,
        word: t('onboarding:sampleWordForWordCloud98'),
      },
      {
        count: 4338,
        word: t('onboarding:sampleWordForWordCloud99'),
      },
    ],
  };
};
